/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_AppointmentsInputs */

const en_admin_statistics_appointments = /** @type {(inputs: Admin_Statistics_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appointments`)
};

const de_admin_statistics_appointments = /** @type {(inputs: Admin_Statistics_AppointmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

/**
* | output |
* | --- |
* | "Appointments" |
*
* @param {Admin_Statistics_AppointmentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_appointments = /** @type {((inputs?: Admin_Statistics_AppointmentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_AppointmentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_appointments(inputs)
	return en_admin_statistics_appointments(inputs)
});